import { config } from 'config';

import s from './Errors.module.css';

export function NotFound() {
  return (
    <div className={s.root}>
      <h1 className={s.title}>Sorry, that page was not found.</h1>
      <p className={s.text}>
        Are you a professional considering GlossGenius for your business?{' '}
        <a className={s.link} href={config.rootUrl}>
          Learn more and sign up here.
        </a>
      </p>
      <p className={s.text}>
        If you are a client of a GlossGenius professional looking to book an
        appointment, check the spelling of your professional&apos;s booking link
        and please try again.
      </p>
    </div>
  );
}
